module.exports = __webpack_public_path__ + "img/a.8b076f72.png";